import { ReactElement, useState } from "react";
import ToggleSidebarContext from "./ToggleSidebarContext";

export default function ToggleSidebarContextProvider({
  children,
}: {
  children: ReactElement;
}) {
  const [collapseSidebar, setCollapseSidebar] = useState(false);

  return (
    <ToggleSidebarContext.Provider
      value={{ collapseSidebar, setCollapseSidebar }}
    >
      {children}
    </ToggleSidebarContext.Provider>
  );
}
